import { FC, useEffect, useState } from 'react';
import { IlogisticServiceDetails, LIST_OF_QUOTE_STATUSES, TQuoteStatus } from 'types/services';
import LogisticServiceDocuments from '../LogisticServiceDocuments/LogisticServiceDocuments';
import { IconGrayClock, IconRedRejected, IconRedWarning, IconSucessGreen } from 'assets/images/services';

import './DocumentsComponent.scss';

const DocumentsComponent: FC<IDocumentsComponent> = ({
  logisticServiceData,
  updateWithLoaders
}: IDocumentsComponent) => {
  const [quoteStatus, setQuoteStatus] = useState<TQuoteStatus>();

  const { quotesLog, manualQuote, quoteDocumentUrl } = logisticServiceData;

  const statusIndicator = (status?: string) => {
    switch (status) {
      case LIST_OF_QUOTE_STATUSES.PENDING:
        return (
          <>
            <div className="grayContainer">Pendiente de aprobación</div>
            <div className="iconContainer">
              <IconGrayClock />
            </div>
          </>
        );
      case LIST_OF_QUOTE_STATUSES.APPROVED:
        return (
          <>
            <div className="greenContainer">Aprobado</div>
            <div className="iconContainer">
              <IconSucessGreen />
            </div>
          </>
        );
      case LIST_OF_QUOTE_STATUSES.REJECTED:
        return (
          <>
            <div className="redContainer">Rechazado</div>
            <div className="iconContainer">
              <IconRedRejected />
            </div>
          </>
        );
      default:
        return (
          <>
            <div className="redContainer">Cargar cotización</div>
            <div className="iconContainer">
              <IconRedWarning />
            </div>
          </>
        );
    }
  };

  const assignQuotationStage = () => {
    if (logisticServiceData?.id) {
      const alternativeToPendingPayment = quoteDocumentUrl && !quotesLog?.status;
      if (quotesLog?.status === LIST_OF_QUOTE_STATUSES.PENDING || alternativeToPendingPayment) {
        return setQuoteStatus('pending');
      }
      if (quotesLog?.status === LIST_OF_QUOTE_STATUSES.APPROVED) return setQuoteStatus('approved');
      if (quotesLog?.status === LIST_OF_QUOTE_STATUSES.REJECTED) return setQuoteStatus('rejected');
      if (!quotesLog?.status) return setQuoteStatus(undefined);
    }
  };
  useEffect(() => {
    assignQuotationStage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logisticServiceData]);

  return (
    <div id="documentsComponent">
      <div className="titleDocuments">Documentos</div>
      <div className="allDocumentsContainer">
        <div className="quoteStatusContainer">
          {manualQuote && (
            <>
              <div className="quoteStatusText">Estado de la cotización:</div>
              <div className="statusColorsContainer"> {statusIndicator(quoteStatus)}</div>
            </>
          )}
        </div>
        <div className="filesListContainer">
          <LogisticServiceDocuments
            logisticServiceData={logisticServiceData}
            updateDataCallback={updateWithLoaders}
            documentsOnly
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentsComponent;

interface IDocumentsComponent {
  logisticServiceData: IlogisticServiceDetails;
  updateWithLoaders: () => Promise<void>;
}
